import React, { useState, forwardRef } from 'react'
import styled from 'particles/themes/styled'
import { theme } from 'theme'

interface ButtonProps {
    clicked: boolean
}

const Button = styled.a<ButtonProps>`
    color: ${({ clicked }) => (clicked ? theme.newColors.primary500 : theme.newColors.primary300)};
`
/**
 *
 * @param outerControl if true the control of clicked state is by parent , to prevent double set clicked state
 */
interface LinkButtonProps extends React.HTMLProps<HTMLAnchorElement> {
    value: string
    outerControl?: boolean
}

const LinkButton: React.ForwardRefRenderFunction<HTMLAnchorElement, LinkButtonProps> = (
    { outerControl = false, href, value, onClick, style, target, onContextMenu, onMouseEnter, onMouseLeave, className },
    ref,
) => {
    const [clicked, setClicked] = useState(false)

    const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        if (!outerControl) {
            setClicked(true)
        }
        if (typeof onClick === 'function') {
            onClick(e)
        }
    }

    return (
        <Button
            ref={ref}
            href={href}
            onClick={handleLinkClick}
            style={style}
            clicked={clicked}
            target={target}
            onContextMenu={onContextMenu}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            className={className}
        >
            {value}
        </Button>
    )
}

export default forwardRef(LinkButton)
